import React from 'react'
import {
  CFImage,
  CFLink,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { yelp, facebook, instagram, zomato } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView mv="20px" column justifyStart>
          <CFView h2 futura bold color="#FF9F00" mb="20px">
            SOCIAL MEDIA
          </CFView>
          <CFView row center white bold>
            <CFLink href="https://www.facebook.com/victoriachimac/">
              <CFImage
                w="45px"
                pr="10px"
                src={facebook}
                alt="Chimac Korean Fried Chicken & Pub Facebook"
              />
            </CFLink>
            <CFLink href="https://www.yelp.ca/biz/chimac-korean-pub-and-fried-chicken-victoria-2">
              <CFImage
                w="45px"
                pr="10px"
                src={yelp}
                alt="Chimac Korean Fried Chicken & Pub Yelp"
              />
            </CFLink>
            <CFLink href="https://www.zomato.com/victoria-bc/chimac-korean-pub-and-fried-chicken-victoria-city-of-victoria">
              <CFImage
                w="45px"
                pr="10px"
                src={zomato}
                alt="Chimac Korean Fried Chicken & Pub Zomato"
              />
            </CFLink>
            {/* <CFLink href="https://www.instagram.com/saladedefruitscafe/?hl=en">
              <CFImage
                w="45px"
                pr="10px"
                src={instagram}
                alt="Chimac Korean Fried Chicken & Pub Instagram"
              />
            </CFLink> */}
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView mb="13px" mt="15px" column justifyStart>
          <CFView h2 futura bold color="#FF9F00" mb="20px">
            SOCIAL MEDIA
          </CFView>
          <CFView row justifyStart alignCenter white bold>
            <CFLink href="https://www.facebook.com/victoriachimac/">
              <CFImage
                w="45px"
                pr="10px"
                src={facebook}
                alt="Chimac Korean Fried Chicken & Pub Facebook"
                hover
              />
            </CFLink>
            <CFLink href="https://www.yelp.ca/biz/chimac-korean-pub-and-fried-chicken-victoria-2">
              <CFImage
                w="45px"
                pr="10px"
                src={yelp}
                alt="Chimac Korean Fried Chicken & Pub Yelp"
                hover
              />
            </CFLink>
            <CFLink href="https://www.zomato.com/victoria-bc/chimac-korean-pub-and-fried-chicken-victoria-city-of-victoria">
              <CFImage
                w="45px"
                pr="10px"
                src={zomato}
                alt="Chimac Korean Fried Chicken & Pub Zomato"
                hover
              />
            </CFLink>
            {/* <CFLink href="https://www.instagram.com/saladedefruitscafe/?hl=en">
              <CFImage
                w="45px"
                pr="10px"
                src={instagram}
                alt="Chimac Korean Fried Chicken & Pub Instagram"
              />
            </CFLink> */}
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
